module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('h6', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageix",
      "title": "ix"
    }
  }), _vm._v("Reformation Commentary on Scripture")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Project Staff"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Project Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("David W. McNutt")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Managing Editor and Production Manager")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Benjamin M. McCoy")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Copyeditor")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jeffrey A. Reimer")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Assistant Project Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Todd R. Hains")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Editorial and Research Assistants")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("David J. Hooper")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Ethan McCarthy")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Assistants to the General Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Le-Ann Little")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jason Odom")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Design")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Cindy Kiple")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Design Assistant")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Beth McGill")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Content Production")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Richard M. Chung")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Maureen G. Tobey")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Daniel van Loon")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jeanna L. Wiggins")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Proofreader")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Travis Ables")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Print Coordinator")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jim Erhart")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91458c6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/credits.vue
// module id = 63
// module chunks = 0